import {
    styled,
    Box,
    DialogContent,
    DialogContentText,
    DialogTitle,
    SxProps,
    Typography,
    useTheme,
    Button,
    IconButton,
} from "@mui/material";
import { StyleguideSavioColors, themeSettings } from "../../../../configuration/themeSettings";
import TextConfirmButton from "../../../AppButtons/TextConfirmButton";
import { AppIconsClose } from "../../../AppIcons";

export const StyledDialogTitle = styled(DialogTitle, {
    label: "AppBasketMenu-BasketCreateDialogTitle",
})(({ theme: Theme }) => ({
    backgroundColor: themeSettings.main.palette.primary.main,
    color: StyleguideSavioColors.white,
    textTransform: "uppercase",
    padding: "9px 9px 6px 20px",
    borderRadius: "2px",
    height: 42,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
}));

export const StyledBox = styled(Box, {
    label: "AppBasketMenu-BasketCreateDialogTitleBox",
})(({ theme: Theme }) => ({
    alignItems: "center",
    display: "flex",
    justifyContent: 'space-between',
    width: '100%',
}));

export const StyledTypographyTitle = styled(Typography, {
    label: "AppBasketMenu-BasketCreateDialogTitleTypography",
})(({ theme: Theme }) => ({
    display: "inline-block",
    paddingLeft: "5px",
    fontSize: 16,
}));

export const TextConfirmButtonStyled = styled(TextConfirmButton, {
    label: "filtersearch-content",
})(({ theme }) => ({

    width: "auto",
    minWidth: 163,

    height: 35,

}));

export const DialogContentStyled = styled(DialogContent, {
    label: "dialog-content-styled",
})(({ theme }) => ({
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: '20px !important',

}));

export const DialogContentTextStyled = styled(DialogContentText, {
    label: "dialog-content-text-styled",
})(({ theme }) => ({
    color: StyleguideSavioColors.text.black,

}));

export const AppIconsCloseStyled = styled(AppIconsClose, {
    label: "app-icons-close-styled",
})(({ theme }) => ({
    fontSize: 19,
    cursor: "pointer",
    
    'svg':{
        fontSize: 18.5,
    }
}));

export const CloseIconWrapper = styled(IconButton)(({ theme }) => ({
    cursor: "pointer",
    
}));
